import styled from 'styled-components';

export const TextAreaStyled = styled.aside`
  .public-DraftStyleDefault-ltr {
    margin: .1rem;
  }
`
